import React, {Component} from 'react';
import Swipeable from 'react-swipeable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './Carousel.less';
import { trackButtonAndLinkClick } from '../../framework/store/FPTI/FPTIActions';
import _ from 'lodash';

export class Carousel extends Component {
    static propTypes = {
        slides: PropTypes.array,
        selectedIndex: PropTypes.number,
        currentPage: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: props.selectedIndex
        };
    }

    getSlideName = (activeIndex) => {
        return _.get(this.props, `slides.${activeIndex - 1}.ICON`, activeIndex);
    };

    getTrackingInfo = (action, currentIndex, newIndex) => {
        const currentPage = this.props.currentPage;
        const currentSlideName = this.getSlideName(currentIndex);
        const newSlideName = this.getSlideName(newIndex);
        const trackingName = `action:${action},from:${currentSlideName},to:${newSlideName}`;
        return trackButtonAndLinkClick({target: {name: trackingName}}, currentPage);
    };

    prevSlide = () => {
        const currentIndex = parseInt(this.state.activeIndex, 10);
        const newIndex = Math.max(1, currentIndex - 1);
        this.setState({ activeIndex: newIndex });
        return this.getTrackingInfo('prev', currentIndex, newIndex);
    };

    nextSlide = () => {
        const currentIndex = parseInt(this.state.activeIndex, 10);
        const newIndex = Math.min(this.props.slides.length, currentIndex + 1);
        this.setState({ activeIndex: newIndex });
        return this.getTrackingInfo('next', currentIndex, newIndex);
    };

    showIndicators = (slides) => {
        return slides.length > 1;
    };

    render() {
        const {slides} = this.props;
        const activeIndex = parseInt(this.state.activeIndex, 10);

        return (
            <div className="CarouselContainer">
                <Swipeable onSwipedLeft={this.nextSlide} onSwipedRight={this.prevSlide}>
                    <div className="slide-indicators-wrapper">
                        <div className="slides-wrapper">
                            {slides.map((item, index) => {
                                return (
                                    <div key={item.ICON} className={index + 1 === activeIndex ? 'slide-show' : 'slide-hide'}>
                                        <div className="headerWrapper">
                                            {item.TITLE}
                                        </div>
                                        <div className={`${item.ICON} slide-image`} />
                                        <div className="footer">
                                            {item.FOOTER}
                                        </div>
                                    </div>
                                );
                            }, this)
                            }
                        </div>
                        <div className="indicators-wrapper">
                            <ul className="indicators">
                                {this.showIndicators(slides) && slides.map((item, index) => {
                                    return (
                                        <li id={`carouselIndicator_${index + 1}`} type="carouselIndicator"
                                            key={item.ICON}
                                            className={index + 1 === activeIndex ? 'active-indicator' : ''}
                                        />
                                    );
                                }, this)
                                }
                            </ul>
                        </div>
                    </div>
                </Swipeable>
            </div>
        );
    }
}

export default connect()(Carousel);

